<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="noise.id > 0; else addTitle">Edit Noise Abatement</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <mat-form-field>
        <mat-select placeholder="Runway *" [(value)]="selectedRunway" name="runway" formControlName="runway">
          <mat-option value="All">All</mat-option>
          <mat-option *ngFor="let runway of runways" [value]=runway>{{ runway }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Applies To *" [(value)]="selectedAppliesTo" name="appliesTo" formControlName="appliesTo">
          <mat-option value="All Aircraft">All Aircraft</mat-option>
          <mat-option value="Category A">Category A</mat-option>
          <mat-option value="Category B">Category B</mat-option>
          <mat-option value="Category C">Category C</mat-option>
          <mat-option value="Category D">Category D</mat-option>
          <mat-option value="Category E">Category E</mat-option>
          <mat-option value="Small Prop">Small Prop</mat-option>
          <mat-option value="Jet/Turbine">Jet/Turbine</mat-option>
          <mat-option value="Rotorcraft">Rotorcraft</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Approach/Departure *" [(value)]="selectedApproachDeparture" name="appDep" formControlName="appDep">
          <mat-option value="Both">Both</mat-option>
          <mat-option value="Approach">Approach</mat-option>
          <mat-option value="Departure">Departure</mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <mat-form-field>
        <input matInput
               placeholder="Text *"
               formControlName="text"
               [(ngModel)]="selectedText">
      </mat-form-field> -->
      <p class="edit-noise__headertext">Noise Abatement Text:</p>
      <mat-form-field hintLabel="Max 1000 characters" class="edit-noise_text__formfield">
        <textarea matInput #text maxlength="1000" name="text" formControlName="text"
                  [(ngModel)]="selectedText" class="edit-noise_text__textarea"></textarea>
        <mat-hint align="end">{{text.value?.length || 0}}/1000</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Noise Abatement
</ng-template>
